import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import { ClientVisit } from "./pages";

const clientVisitRoutes = [
  {
    path: "/presence/client-visit",
    element: (
      <ProtectedRoute name="client_visit">
        <ClientVisit />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="client_visit"
        defaultTitle="clientVisit.title"
      />
    ),
  },
];

export default clientVisitRoutes;
